import React from 'react';
import moment from 'moment';
import {
  TableFilters,
  TableFilterSelect,
  InputContainer,
  DatePicker,
  BelongsToFilterSelects,
} from '../../design-system';
import { extendContainerValidator } from '../../utils';
import { i18n } from '../../i18n';
import {
  containerTypes,
  containerStatues,
  INPUT_ERRORS,
  containerConditionOptions,
} from '../../const';
import { useStoreUser } from '../../context';

interface Props {
  number?: string;
  type?: string;
  condition?: string;
  startDate?: any;
  endDate?: any;
  status?: any;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  number = '',
  type,
  condition,
  startDate,
  endDate,
  status,
  setStates,
}: Props) => {
  const { user } = useStoreUser();

  return (
    <TableFilters className="table-filters">
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
      />
      {!Array.isArray(number) && (
        <InputContainer
          label={i18n.t('label.containerNumber')}
          data-size={'medium'}
          defaultValue={number}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            setStates('number', value);
          }}
          helperText={
            number.length !== 0 && number.length < 3
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
              : !extendContainerValidator(number)
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
              : ''
          }
          alwaysShowHelperText
        />
      )}
      <TableFilterSelect
        label={i18n.t('label.type')}
        options={containerTypes}
        value={type}
        onChange={(e) => setStates('force', { type: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.condition')}
        options={containerConditionOptions}
        value={condition}
        onChange={(e) => setStates('force', { condition: e.target.value })}
      />
      {!Array.isArray(number) && (
        <TableFilterSelect
          label={i18n.t('label.status')}
          options={containerStatues(user.canTrade)}
          value={status}
          onChange={(e) => {
            setStates('force', {
              status: e.target.value,
              startDate: null,
              endDate: null,
            });
          }}
        />
      )}
      {(status === 'GATED_IN' || status === 'GATED_OUT') &&
        [status].map(() => (
          <React.Fragment key={Math.random()}>
            <DatePicker
              label={i18n.t('label.from')}
              data-size={'medium'}
              defaultValue={startDate}
              onChange={(e) => setStates('force', { startDate: e })}
              maxDate={endDate ? moment(endDate) : moment()}
            />
            <DatePicker
              label={i18n.t('label.to')}
              data-size={'medium'}
              defaultValue={endDate}
              onChange={(e) => setStates('force', { endDate: e })}
              minDate={startDate ? moment(startDate) : null}
              maxDate={moment()}
            />
          </React.Fragment>
        ))}
    </TableFilters>
  );
};
